import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/web.timers";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
*/
import { getStore } from '../../store/store';
import { workingStart, workingEnd, hideSpinner } from 'wfui-digital-core/es/actions';
import { showStopMessage } from '../../store/stop-message/actions';
import fetchSamlDetails from '../support/fetch-saml-details';
import locationNavigation from '../navigation-types/location-navigation';
import browserNavigation from '../navigation-types/browser-navigation';
import modalNavigation from '../navigation-types/modal-navigation';
import globals from '../../globals/globals';
import { showConfirmation } from '../../store/navigation/actions';
import getString from '../../strings/get-string';
import logger from '../../logger/logger';
var navigationType = 'SAML navigation';
var defaultOptions = {
  testNetwork: true,
  showSpinner: true
}; // Start the location navigation process. Showing the spinner on the overlay is optional
// Returns the settings

var _start = function _start(navigation) {
  getStore().dispatch(workingStart({
    showSpinner: !globals().nativeWrapped,
    overlayDelay: 800
  }));
  var settings = Object.assign({}, defaultOptions, navigation);
  logger.debug("".concat(navigationType, ": Starting"));
  return Promise.resolve(settings);
};

var _handleInternal = function _handleInternal(navigation) {
  return locationNavigation(navigation);
};

var _handleExternal = function _handleExternal(url, navigation) {
  if (url.indexOf('depositCheck.action') > -1) {
    if (globals().legacyIpadApp) {
      // eslint-disable-next-line
      navigation.onCloseExecute = 'javascript:window.onCheckDepositModalClose()';
      return modalNavigation(navigation);
    } else {
      return locationNavigation(navigation);
    }
  } else {
    return modalNavigation(navigation);
  }
};

var _handleExternalLarge = function _handleExternalLarge(navigation) {
  navigation.displaySize = 'large';
  return modalNavigation(navigation);
};

var _handleExternalBrowser = function _handleExternalBrowser(navigation) {
  return browserNavigation(navigation);
};

var _confirmSamlNavigation = function _confirmSamlNavigation(navigation) {
  navigation.confirmationDeclined = false;
  var samlDetails = navigation.samlDetails;
  return new Promise(function (resolve, reject) {
    if (navigation.samlDetails.displayMessageText) {
      getStore().dispatch(workingEnd());
      new Promise(function (confirmResolve, confirmReject) {
        getStore().dispatch(showConfirmation({
          confirmationType: 'saml',
          samlDetails: samlDetails,
          confirmResolve: confirmResolve,
          confirmReject: confirmReject
        }));
      }).then(function () {
        getStore().dispatch(workingStart({
          overlayDelay: 0
        }));
        resolve(navigation);
      }, function () {
        navigation.confirmationDeclined = true;
        navigation.failureReason = 'Confirmation declined';
        reject(navigation);
      });
    } else {
      resolve(navigation);
    }
  });
};

var _doNavigation = function _doNavigation(navigation) {
  var samlDetails = navigation.samlDetails;
  var url = samlDetails.destinationUrl;

  if (samlDetails.dispatch) {
    navigation.failureReason = 'dispatch not supported';
    return Promise.reject(navigation);
  } else {
    logger.debug("".concat(navigationType, ": Routing - ").concat(samlDetails.browserMode));
    navigation.navigationItem.initiatedFromSAML = true;
    navigation.navigationItem.url = url;

    switch (samlDetails.browserMode) {
      case 'internal':
        return _handleInternal(navigation);

      case 'external':
        return _handleExternal(url, navigation);

      case 'externalLarge':
        return _handleExternalLarge(navigation);

      case 'externalBrowser':
        return _handleExternalBrowser(navigation);

      default:
        {
          navigation.failureReason = "Unknown SAML browser mode: ".concat(samlDetails.browserMode);
          return Promise.reject(navigation);
        }
    }
  }
};

var _cleanup = function _cleanup(navigation) {
  logger.debug("".concat(navigationType, ": Cleanup"));

  if (globals().nativeWrapped) {
    getStore().dispatch(hideSpinner());
    setTimeout(function () {
      return getStore().dispatch(workingEnd());
    }, 2000);
  }

  return Promise.resolve(navigation);
};

export default (function (navigation) {
  return new Promise(function (resolve, reject) {
    return _start(navigation).then(fetchSamlDetails).then(_confirmSamlNavigation).then(_doNavigation).then(_cleanup).then(function (_navigation) {
      logger.debug("".concat(navigationType, ": Finished"));
      resolve(_navigation);
    }, function (result) {
      if (result.interdictionRequested) {
        logger.debug("".concat(navigationType, ": Interdiction requested"));
        navigation.failureReason = 'Interdiction requested';
      } else if (result.confirmationDeclined) {
        getStore().dispatch(workingEnd());
        logger.debug("".concat(navigationType, ": Confirmation declined"));
      } else {
        logger.warn("".concat(navigationType, " failed: ").concat(result.navigationItem.failureReason));
        logger.debug("".concat(navigationType, ": Show stop message"));
        getStore().dispatch(workingEnd());
        getStore().dispatch(showStopMessage(getString('global.no.internet.connection')));
      }

      reject(navigation);
    });
  });
});